import { render, staticRenderFns } from "./spaceImage.vue?vue&type=template&id=57b543f3&scoped=true&"
import script from "./spaceImage.vue?vue&type=script&lang=js&"
export * from "./spaceImage.vue?vue&type=script&lang=js&"
import style0 from "./spaceImage.vue?vue&type=style&index=0&id=57b543f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b543f3",
  null
  
)

component.options.__file = "spaceImage.vue"
export default component.exports